import { render } from "./SentimentCircleIcon.vue?vue&type=template&id=1efd8661&scoped=true"
import script from "./SentimentCircleIcon.vue?vue&type=script&lang=js"
export * from "./SentimentCircleIcon.vue?vue&type=script&lang=js"

import "./SentimentCircleIcon.vue?vue&type=style&index=0&id=1efd8661&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efd8661"]])

export default __exports__